export function Eyebrow({ children, className = "" }: { children: React.ReactNode; className?: string }) {
  return (
    <p
      className={`inline-flex max-w-full items-center whitespace-nowrap text-[10px] tracking-[0.15em] md:whitespace-normal md:text-[11px] md:tracking-[0.3em] font-medium uppercase text-foreground mb-5 ${className}`}
    >
      <span className="min-w-0">{children}</span>
    </p>
  );
}
